/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {useRouter} from 'next/router';
import {OfficeBuildingIcon} from '@heroicons/react/solid';

import Link from '../../components/Link';
import {RightArrowIcon} from '../../components/svg';
import {useAnalytics} from '../../hooks';

const CompanyCard = ({company}) => {
  const {tracker} = useAnalytics();
  const router = useRouter();
  const url = `/companies/${company.id}`;

  const handleClick = () => {
    tracker.directoryClick({tag: company.id});
    router.push(url);
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer flex flex-col h-full text-left p-6 pb-5 shadow rounded border border-gray-200"
    >
      <div>
        {company.image_url ? (
          <img
            className="h-12"
            src={company.image_url}
            alt={company.name}
          />
        ) : (
          <OfficeBuildingIcon className="h-12 text-gray-300" />
        )}
        <Link href={url} className="block mt-4 text-xl font-semibold leading-6 text-black">
          {company.name}
        </Link>
      </div>
      <div className="flex flex-col justify-between h-full">
        <span
          className="block text-right text-indigo text-sm font-semibold pt-2 pb-1 hover:text-indigo focus:text-indigo cursor-pointer"
        >
          View company
          <RightArrowIcon className="w-4 ml-1.5" />
        </span>
      </div>
    </div>
  );
};

export default CompanyCard;
